const BenefitsSection = () => {
  const benefits = [
    {
      icon: '🎯',
      title: 'Identify Your Weak Points',
      description: 'Get a clear picture of where you need to improve with detailed feedback on technical knowledge, communication, and problem-solving approach.',
      outcome: 'Know exactly what to study and practice before your real interview'
    },
    {
      icon: '💪',
      title: 'Build Unshakeable Confidence',
      description: 'Experience real interview pressure in a safe environment. Learn to handle tough questions, think on your feet, and stay calm under pressure.',
      outcome: 'Walk into your real interview feeling prepared and confident'
    },
    {
      icon: '📊',
      title: 'Get Honest, Expert Feedback',
      description: 'Receive candid insights from senior engineers who have conducted hundreds of real interviews. No sugar-coating, just actionable advice.',
      outcome: 'Avoid common mistakes that cost candidates job offers'
    },
    {
      icon: '🚀',
      title: 'Practice Real Interview Scenarios',
      description: 'Face questions and coding challenges from actual company interviews. Learn the patterns, best practices, and what interviewers really look for.',
      outcome: 'Be ready for anything your interviewer throws at you'
    },
    {
      icon: '⏱️',
      title: 'Master Time Management',
      description: 'Learn to pace yourself, prioritize what matters, and complete coding challenges within time limits without sacrificing quality.',
      outcome: 'Finish problems completely while explaining your thinking'
    },
    {
      icon: '💼',
      title: 'Stand Out From Other Candidates',
      description: 'Learn how to present your experience effectively, tell compelling stories, and demonstrate both technical skills and cultural fit.',
      outcome: 'Make interviewers excited to work with you'
    }
  ];

  return (
    <section id="benefits-section" className="py-10 bg-gradient-to-br from-gray-50 to-orange-50">
      <div className="container mx-auto max-w-7xl px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Mock Interviews Are Your Secret Weapon
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't leave your career to chance. Here's how our mock interviews transform nervous candidates into confident professionals.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              {/* Icon */}
              <div className="text-5xl mb-4">{benefit.icon}</div>

              {/* Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 mb-4 leading-relaxed">
                {benefit.description}
              </p>

              {/* Outcome */}
              <div className="pt-4 border-t border-gray-200">
                <div className="flex items-start gap-2">
                  <span className="text-green-500 font-bold flex-shrink-0 mt-1">✓</span>
                  <p className="text-sm font-semibold text-green-700">
                    {benefit.outcome}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center bg-gradient-to-r from-green-700 to-emerald-700 rounded-2xl p-10 text-white shadow-2xl">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Ready to Stop Wondering "What If" and Start Landing Offers?
          </h3>
          <p className="text-lg text-green-100 mb-6 max-w-2xl mx-auto">
            Every day you wait is another day of uncertainty. Book your mock interview now and know exactly where you stand.
          </p>
          <button
            onClick={() => {
              const pricingSection = document.getElementById('pricing-section');
              if (pricingSection) {
                pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg rounded-lg shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            Choose Your Plan →
          </button>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
